import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Mail } from "lucide-react";

export default function Success() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const raw = sessionStorage.getItem("hireflow_sent");
    if (raw) setInfo(JSON.parse(raw));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-xl w-full bg-white border border-slate-200 rounded-2xl p-10 md:p-12 text-center shadow-[0_8px_30px_-12px_rgba(0,0,0,0.1)] hf-fade-up" data-testid="success-card">
        <div className="w-20 h-20 mx-auto bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center mb-6">
          <CheckCircle2 size={42} strokeWidth={2.2} />
        </div>
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">
          {info?.email_sent === false ? "Η φόρμα παρελήφθη επιτυχώς" : "Η φόρμα στάλθηκε επιτυχώς"}
        </h1>
        <p className="text-slate-600 mt-4 font-medium">
          {info?.email_sent === false
            ? "Τα στοιχεία σας καταχωρήθηκαν. Θα επικοινωνήσουμε μαζί σας σύντομα."
            : `Το PDF της φόρμας πρόσληψης${info?.recipients?.length ? ` αποστάλθηκε σε ${info.recipients.length} παραλήπτες` : ""} μαζί με το βιογραφικό σας.`}
        </p>

        {info?.recipients?.length > 0 && info?.email_sent !== false && (
          <div className="mt-6 bg-slate-50 border border-slate-200 rounded-xl p-4 text-left">
            <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2 flex items-center gap-2">
              <Mail size={14} /> Παραλήπτες
            </div>
            <ul className="text-sm text-slate-700 font-medium space-y-1">
              {info.recipients.map((r) => <li key={r}>· {r}</li>)}
            </ul>
          </div>
        )}

        {info?.id && (
          <p className="text-xs text-slate-400 mt-6 font-mono">Κωδικός: {info.id}</p>
        )}

        <Link
          to="/"
          className="inline-block mt-8 h-12 px-8 bg-blue-700 hover:bg-blue-800 text-white font-bold rounded-xl leading-[48px] transition-all"
          data-testid="back-home-btn"
        >
          Νέα Υποβολή
        </Link>
      </div>
    </div>
  );
}
